<template>
  <footer class="container border-top border-2 py-3 mt-5">
    <div class="d-xl-flex">
      <div class="d-lg-flex gap-4 ja-links">
        <a href="#" class="text-decoration-none text-secondary fs-14px"
          >الشروط والأحكام</a
        >
        <a href="#" class="text-decoration-none text-secondary fs-14px"
          >سياسة الخصوصية</a
        >
        <a href="#" class="text-decoration-none text-secondary fs-14px"
          >العروض والباقات</a
        >
        <a href="#" class="text-decoration-none text-secondary fs-14px"
          >الدعم</a
        >
        <a href="#" class="text-decoration-none text-secondary fs-14px"
          >إتفاقية الكوكيز</a
        >
      <div class="d-lg-none d-flex align-items-center fs-14px">
        <a href="#" class="me-2 text-decoration-none text-secondary fs-14px"
          >English</a
        >
        <img src="@/assets/images/uk.svg" width="18" alt="" />
      </div>
      </div>
      <!-- Desktop -->
      <div class="d-lg-flex d-none ms-auto align-items-center my-xl-0 my-3 fs-14px">
        <a href="#" class="me-2 text-decoration-none text-secondary fs-14px"
          >English</a
        >
        <img src="@/assets/images/uk.svg" width="18" alt="" />
      </div>
    </div>
    <div class="text-secondary fs-14px pt-3 copyright">
      جميع الحقوق محفوظة (c) لجدولها 2022
     أحد منتجات <a href="#">مساق</a>
    </div>
  </footer>
</template>